import { useCallback } from "react";

import useTranslations from "@/shared/lang/useTranslations";
import { colocaToast } from "@/shared/utils/toast";

/** Copy-to-clipboard with feedback that names WHAT was copied. */
export function useCopyValue(): (value: string, fieldLabel: string) => Promise<void> {
  const { t } = useTranslations("cryptoSwaps");

  return useCallback(
    async (value: string, fieldLabel: string) => {
      try {
        await navigator.clipboard.writeText(value);
        colocaToast.success(t("copy_done", { field: fieldLabel }));
      } catch {
        colocaToast.error(t("copy_failed"));
      }
    },
    [t],
  );
}
